import { FC, useCallback } from "react";
import { Flex, Icon, IconButton, Text } from "components";
import { IChangeRoleColumn } from "./types";
import { isTeamOwnerRow } from "./utils";
import { theme } from "@ovou-inc/ovou-ui";
import { useCheckPermission, useIsActionAllowed, useTracking } from "hooks";
import { FEATURES, FEATURE_ACTION } from "constants/features";
import { ANALYTICS_EVENTS } from "constants/analyticEvents";
import { useUpgradeModal } from "hooks/useUpgradeModal";

const ChangeRoleColumn: FC<IChangeRoleColumn> = ({ row, onClick }) => {
  const track = useTracking();
  const canEditRole = useCheckPermission(
    FEATURE_ACTION.EDIT,
    FEATURES.MANAGE_USERS_CHANGE_ROLE,
  );
  const { handleAction } = useIsActionAllowed();
  const { openModal } = useUpgradeModal();
  const { permission_metadata: metadata } = row;

  const handleClick = useCallback(() => {
    handleAction(
      canEditRole,
      FEATURES.MANAGE_USERS_CHANGE_ROLE,
      () => {
        onClick(row);
        track({
          eventName: ANALYTICS_EVENTS.MANAGE_USERS_OPEN_CHANGE_ROLE_MODAL,
        });
      },
      openModal,
    );
  }, [canEditRole, row, openModal]);

  return (
    <Flex alignItems="center">
      <Text width="100px">{metadata.label}</Text>

      {!isTeamOwnerRow(row) && (
        <IconButton
          aria-label="Edit user role"
          variant="grey"
          borderRadius="0.5rem"
          border={`1px solid ${theme.palette.ui.greys.grey3}`}
          size="md"
          icon={<Icon name="edit" strokeWidth="1.5" />}
          onClick={handleClick}
        />
      )}
    </Flex>
  );
};

export default ChangeRoleColumn;
